import { Plus, Trash2 } from "lucide-react";

export const blankVariant = () => ({ sku: "", size: "", load_speed: "", price_usd: "", stock: "" });
export const toPayload = (variants) =>
  variants.map((v) => ({ sku: v.sku.trim(), size: v.size.trim(), load_speed: v.load_speed.trim(), price_usd: Number(v.price_usd), stock: Number(v.stock) }));

export function VariantEditor({ value, onChange, testId }) {
  const set = (i, key) => (e) => onChange(value.map((v, j) => (j === i ? { ...v, [key]: e.target.value } : v)));
  return (
    <div className="variant-editor" data-testid={testId}>
      <div className="variant-row head">
        <span>Size *</span>
        <span>Load / speed</span>
        <span>Price USD *</span>
        <span>Stock *</span>
        <span>SKU (auto if blank)</span>
        <span />
      </div>
      {value.map((v, i) => (
        <div className="variant-row" key={i} data-testid={`${testId}-row-${i}`}>
          <input required minLength={3} value={v.size} onChange={set(i, "size")} placeholder="225/45 R17" data-testid={`${testId}-size-${i}`} />
          <input value={v.load_speed} onChange={set(i, "load_speed")} placeholder="94W XL" data-testid={`${testId}-load-${i}`} />
          <input required type="number" min="0.01" step="0.01" value={v.price_usd} onChange={set(i, "price_usd")} data-testid={`${testId}-price-${i}`} />
          <input required type="number" min="0" step="1" value={v.stock} onChange={set(i, "stock")} data-testid={`${testId}-stock-${i}`} />
          <input value={v.sku} onChange={set(i, "sku")} placeholder="Auto" data-testid={`${testId}-sku-${i}`} />
          <button type="button" className="variant-remove" disabled={value.length === 1} onClick={() => onChange(value.filter((_, j) => j !== i))} aria-label="Remove size" data-testid={`${testId}-remove-${i}`}>
            <Trash2 size={15} />
          </button>
        </div>
      ))}
      <button type="button" className="variant-add" onClick={() => onChange([...value, blankVariant()])} data-testid={`${testId}-add`}>
        <Plus size={14} /> Add size
      </button>
    </div>
  );
}
